export type PlatformName = 'web' | 'ios' | 'android';

/** Capacitor adapters land in Phase 3. Until then every build is web. */
export function detectPlatform(): PlatformName {
  return 'web';
}

export function hapticsAvailable(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
}

export function vibrate(pattern: number | number[]): void {
  if (hapticsAvailable()) navigator.vibrate(pattern);
}
